import React from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

const STORAGE_KEY = "distributionPortal.companyId";

export const getSelectedDistributionCompanyId = () => {
  try {
    const value = Number(sessionStorage.getItem(STORAGE_KEY));
    return value > 0 ? value : null;
  } catch {
    return null;
  }
};

export const setSelectedDistributionCompanyId = (companyId) => {
  try {
    if (companyId) sessionStorage.setItem(STORAGE_KEY, String(companyId));
    else sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // sessionStorage unavailable
  }
};

export const isSystemAdminContext = (context) =>
  (context?.isSystemAdmin ?? context?.IsSystemAdmin) === true;

const DistributionCompanySelect = ({ context, onChange }) => {
  if (!isSystemAdminContext(context)) return null;

  const companies = context?.companies ?? context?.Companies ?? [];
  const selectedId =
    context?.distributionCompanyId ?? context?.DistributionCompanyId ?? "";

  return (
    <FormControl size="small" sx={{ minWidth: 240 }}>
      <InputLabel id="distribution-portal-company">شرکت توزیع</InputLabel>
      <Select
        labelId="distribution-portal-company"
        label="شرکت توزیع"
        value={selectedId ? String(selectedId) : ""}
        onChange={(e) => {
          const id = Number(e.target.value) || null;
          setSelectedDistributionCompanyId(id);
          onChange?.(id);
        }}
      >
        {companies.map((c) => {
          const id = c.id ?? c.Id;
          return (
            <MenuItem key={id} value={String(id)}>
              {c.name ?? c.Name}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default DistributionCompanySelect;
